module.exports = __webpack_public_path__ + "39f044c8322b2e3dd374d91c2209e6a3.svg";